import React from 'react';
import Slider from 'react-slick';
import { images } from '../../../assets/images'
import { renderImage } from '../../../Components/helper/image';


/* function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-right"></i>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-left"></i>
        </div>
    );
} */

function TestimonialSlider(props) {
    var settings = {
        autoplay: true,
        dots: true,
        infinite: true,
        speed: 2500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
        /* nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow /> */
    };
    return (
        <div className="testimonial_slider">
            <Slider {...settings}>
                {props && props.item && props.item.testimonials.map((item, index) => (
                    <div key={index} className="testimonial_item text-center">
                        <div className="testimonial_content">
                            <p>
                                {item.designation}
                            </p>
                        </div>
                        <div className="testimonial_info">
                            <div className="testi_img">
                                <img src={item.image ? renderImage(item.image, 'small') : images.noimage} alt="..." className="img-fluid d-block mx-auto" />
                            </div>
                            <h4>{item.name}</h4>
                            <h5>{item.description}</h5>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export { TestimonialSlider };
